<template>
  <div v-show="show" class="backTop">
    <!-- <div>
      <a href="tel:15228593532"><img src="../../assets/images/call.png" alt="" /></a>
    </div> -->
    <div @click="backTop">
      <img src="../../assets/images/toTop.png" />
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { backTop } from '@/util'

export default {
  setup() {
    const state = reactive({
      show: false
    })

    onMounted(() => {
      let clientHeight = document.documentElement.clientHeight
      window.addEventListener(
        'scroll',
        () => {
          let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
          let height = clientHeight * 0.5
          //滚动条的高度>可视区的高度
          state.show = scrollTop > height
        },
        true
      )
    })
    return {
      ...toRefs(state),
      backTop
    }
  }
}
</script>

<style lang="scss" scoped>
.backTop {
  position: fixed;
  right: 0;
  top: 65vh;
  div {
    background: rgba(0, 0, 0, 0.5);
    padding: 6px 16px 5px;
    border-radius: 16px 0 0 16px;
    margin-top: 10px;
  }
  img {
    width: 20px;
  }
}
</style>
